import React, { Component } from 'react';

const styles = `
  .eye-icon {
    position: absolute;
    right: 10px;
    top: 40%;
    transform: translateY(-100%);
    cursor: pointer;
  }
`;

const eyeOpen = (<svg fill='none' width='24' height='24' xmlns='http://www.w3.org/2000/svg'>
<path d='M12 5C5.63636 5 2 12 2 12C2 12 5.63636 19 12 19C18.3636 19 22 12 22 12C22 12 18.3636 5 12 5Z' stroke='#000000' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
<path d='M12 15C13.6569 15 15 13.6569 15 12C15 10.3431 13.6569 9 12 9C10.3431 9 9 10.3431 9 12C9 13.6569 10.3431 15 12 15Z' stroke='#000000' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
</svg>);
const eyeClosed = (<svg fill='none' width='24' height='24' xmlns='http://www.w3.org/2000/svg'>
<path d='M20 14.8335C21.3082 13.3317 22 12 22 12C22 12 18.3636 5 12 5C11.6588 5 11.3254 5.02013 11 5.05822C10.6578 5.09828 10.3244 5.15822 10 5.23552M12 9C12.3506 9 12.6872 9.06015 13 9.17071C13.8524 9.47199 14.528 10.1476 14.8293 11C14.9398 11.3128 15 11.6494 15 12M3 3L21 21M12 15C11.6494 15 11.3128 14.9398 11 14.8293C10.1476 14.528 9.47198 13.8524 9.1707 13C9.11386 12.8392 9.07034 12.6721 9.04147 12.5M4.14701 9C3.83877 9.34451 3.56234 9.68241 3.31864 10C2.45286 11.1282 2 12 2 12C2 12 5.63636 19 12 19C12.3412 19 12.6746 18.9799 13 18.9418' stroke='#000000' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round'/>
</svg>);

class PasswordFields extends Component {
  static defaultProps = {
    id: '',
    name: 'default',
    label: 'Password',
    errorMessage: '',
    renderErrorMessage: () => {},
    autoFocus: false,
    autoComplete: undefined,
    // Apple/WebKit hint so generated strong passwords satisfy our rules.
    passwordRules: undefined,
    describedBy: undefined,
    onBlur: () => {},
  }
  constructor(props) {
    super(props);
    this.state = {
      profile: {
        password: '',
      },
      showPassword: false
    };
    this.id = this.props.id;
    this.name = this.props.name;
    this.label = this.props.label;
  }


  togglePasswordVisibility = (field) => {
    this.setState((prevState) => ({
      [field]: !prevState[field]
    }));
  };

  render() {
    const { profile, showPassword } = this.state;
    const { passwordValue, errorMessage, updateInput, renderErrorMessage, autoFocus } = this.props;

    return (
      <div className='form-floating'>
        <div style={{position: 'relative'}}>
          <input
            id={this.id}
            className={`form-control ${errorMessage ? 'is-invalid' : ''}`}
            name={this.name}
            type={showPassword ? 'text' : 'password'}
            placeholder={this.label}
            value={passwordValue}
            onChange={updateInput}
            onBlur={this.props.onBlur}
            autoFocus={autoFocus}
            autoComplete={this.props.autoComplete}
            passwordrules={this.props.passwordRules}
            aria-describedby={this.props.describedBy}
            style={{paddingRight:'2em'}}
          />
          <span
            className='eye-icon'
            onClick={() => this.togglePasswordVisibility('showPassword')}
            style={{position: 'absolute', top:'50%', right: '5px', marginTop: '-12px', cursor: 'pointer'}}
            color={showPassword ? 'gray' : 'black'}
            >
            {/*showPassword ? '👁️' : '👁️'*/}
            {showPassword ? eyeOpen : eyeClosed}
          </span>
        </div>
        <label htmlFor={this.id} className='form-label'>{this.label}</label>
          
        {renderErrorMessage(errorMessage)}
      </div>
    );
  

    return (
      <div className="row g-2">
        <div className="col">
          <div className="form-floating">
            <input
              id="password-input"
              className={`form-control ${this.props.valErrs.password ? 'is-invalid' : ''}`}
              name="password"
              type={showPassword ? 'text' : 'password'}
              placeholder="Password"
              value={profile.password}
              onChange={this.updateInput} />
            <label htmlFor="password-input" className="form-label">Password</label>
            <span
              className="eye-icon"
              onClick={() => this.togglePasswordVisibility('showPassword')}>
              {showPassword ? '👁️' : '👁️'}
            </span>
            {this.props.renderErrorMessage(this.props.valErrs.password)}
          </div>
        </div>
        <div className="col">
          <div className="form-floating">
            <input
              id="confirm-password-input"
              className={`form-control ${this.props.valErrs.confirm_password ? 'is-invalid' : ''}`}
              name="confirm_password"
              type={showConfirmPassword ? 'text' : 'password'}
              placeholder="Confirm password"
              value={profile.confirm_password}
              onChange={this.updateInput} />
            <label htmlFor="confirm-password-input" className="form-label">Confirm Password</label>
            <span
              className="eye-icon"
              onClick={() => this.togglePasswordVisibility('showConfirmPassword')} style={{cursor:"pointer"}}>
              {showConfirmPassword ? '👁️' : '👁️'}
            </span>
            {this.props.renderErrorMessage(this.props.valErrs.confirm_password)}
          </div>
        </div>
      </div>
    );
  }
}

export default PasswordFields;
